import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';
import { EnvType, getOidcSettings } from '@easy-lib/modules/shared/models';
import { envProdDefault } from '@easy-lib/modules/shared/models/environment.default.production';

const spaAppUrl = 'https://m.orbis.easytrader.ir';

export const environment: EasyEnvironment = {
	version: '2.5.0',
	build: '9129',
	...envProdDefault,
	appUrl: spaAppUrl,
	oidcSettings: getOidcSettings(EnvType.PROD, spaAppUrl)
};
